<template>
  <div class="mains">
    <div>
      <el-button type="primary"
                 @click="addGoods">新增</el-button>
    </div>
    <div class="table">
      <el-table :data="tableData"
                border
                :row-class-name="handleCurrentIndex"
                @row-click='handleCurrentChange'
                highlight-current-row
                ref="multipleTable"
                style="width: 100%">
        <el-table-column type="index"
                         label="序号">
        </el-table-column>
        <el-table-column prop="imgs_mains"
                         label="商品图片"
                         width="180">
          <template slot-scope="scope">
            <img :src="scope.row.imgs_mains"
                 style="width:80px">
          </template>
        </el-table-column>
        <el-table-column prop="id"
                         label="商品ID"
                         width="180">
        </el-table-column>
        <el-table-column prop="tits"
                         label="商品名称">
        </el-table-column>
        <el-table-column prop="address"
                         label="操作">
          <template slot-scope="scope">
            <el-link type="danger"
                     @click="setdecorateGoodsDel(scope.row.id,scope.row.recom_sort)">删除</el-link>
          </template>
        </el-table-column>
      </el-table>
      <div class="btn">
        <el-button @click="upmove"><i class="el-icon-arrow-up"></i></el-button>
        <el-button @click="downmove"><i class="el-icon-arrow-down"></i></el-button>

      </div>
    </div>
    <div v-if="viewDetail">
      <fixAddGoods @closeModel='initModel'
                   :titles='titles'
                   :method='getdecorateGoodsList'
                   :tableindex='tableindex'></fixAddGoods>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import fixAddGoods from './fixAddGoods.vue'
export default {
  props: {

  },
  data () {
    return {
      viewDetail: false,
      flag: false,
      indexRow: '',
      tableData: [],
      type: 1,
      titles:'添加商品',
      rowIndex:0
    };
  },
  computed: {
    ...mapGetters({
      getToken: "getToken",
    }),
  },
  watch: {
    tableData: function() {
      this.$nextTick(function() {
        this.$refs.multipleTable.setCurrentRow(this.tableData[0])
      })
       this.indexRow = this.tableData[0]
    }
  },
  mounted() {
     this.$nextTick(()=>{
            this.$refs.multipleTable.setCurrentRow(
            this.tableData[this.rowIndex],
            true
          );})
  },
  methods: {
    ...mapActions({
      decorateGoodsList: "detect/decorateGoodsList", //列表
      decorateGoodsSort: "detect/decorateGoodsSort", //排序
      decorateGoodsDel: "detect/decorateGoodsDel", //删除
    }),
    handleCurrentChange (row) {
      this.indexRow = row
    },
    handleCurrentIndex ({ row, rowIndex }) {
   row.index = rowIndex
    },
    upmove () {
      this.type = 1
      let index = ''
      let p_index=this.indexRow.index
      index = this.indexRow.recom_sort
      if (p_index==0) {
        this.$message.error('商品排序已在第一位');
      } else {
        this.setdecorateGoodsSort(index)
     }
    },
    downmove () {
      this.type = 2
      let index = this.indexRow.recom_sort
       let p_index=this.indexRow.index
      if (p_index==this.tableData.length-1) {
        this.$message.error('商品排序已在最后一位');
      } else {
          this.setdecorateGoodsSort(index)
        /* const len = this.tableData[index + 1]
        this.$set(this.tableData, index + 1, this.tableData[index])
        this.$set(this.tableData, index, len) */
      }
    },
    addGoods () {
      if (this.tableData.length == 10) {
        this.$message.error('主推商品位置已满，暂无法添加新主推商品！您可以先删除已有主推商品再进行新增');
      } else {
        this.tableindex = this.tableData.length
        this.viewDetail = true
      }
      /*  */
    },
    initModel () {
      this.viewDetail = false
    },
    getdecorateGoodsList () {
      let params = {
        token: this.getToken,
        shop_id: this.$route.query.id,
        page: 1,
        limit: 10,
        is_recom: 1
      }
      this.decorateGoodsList(params).then(res => {
        if (res.data.code == 1) {
          this.tableData = res.data.data.list
        } else {
          this.$message.error(res.data.msg);
        }

      })
    },
    setdecorateGoodsSort (index) {
      let params = {
        token: this.getToken,
        shop_id: this.$route.query.id,
        type: this.type,
        sort: index
      }
      this.decorateGoodsSort(params).then(res => {
        if (res.data.code == 1) {
          this.getdecorateGoodsList()
       /*    const len = this.tableData[index - 1]
          this.$set(this.tableData, index - 1, this.tableData[index])
          this.$set(this.tableData, index, len) */
        } else {
          this.$message.error(res.data.msg);
        }

      })
    },
    setdecorateGoodsDel (index, sort) {
      let params = {
        token: this.getToken,
        shop_id: this.$route.query.id,
        goods_id: index,
        recom_sort: sort
      }
      this.decorateGoodsDel(params).then(res => {
        if (res.data.code == 1) {
          this.getdecorateGoodsList()

        } else {
          this.$message.error(res.data.msg);
        }

      })
    }

  },
  components: {
    fixAddGoods
  },
};
</script>

<style scoped lang="scss">
.mains {
  width: 80%;
  padding: 20px;
  border: 1px solid #ccc;
  margin: 0 auto;
  .table {
    width: 800px;
    /*  border: 1px solid #ccc; */
    padding: 20px;
    margin: 0 auto;
  }
}
.btn {
  padding: 20px 0;
  text-align: center;
}
</style>
